/* eslint-disable no-unused-vars  */

export enum GlobalEvents {
  BREAKPOINT_CHANGE = 'BREAKPOINT_CHANGE',
  DOM_READY = 'DOM_READY',
  TEMPLATE_READY = 'TEMPLATE_READY',
}
